import { PaginationType } from '@edikk-edikk/pagination';
import { ButtonSize, PaginationLoadMore } from '@edikk-edikk/country-layout-black';
import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useApi } from '#hooks/use-api';
import { useAdvertListContext } from '#advertList/hooks';

type PropsType = {
  pagination: PaginationType;
  serviceId?: number|null;
};

const LoadMore: FC<PropsType> = ({
  pagination,
  serviceId,
}) => {
  const {
    categoryId,
    nationalityId,
    cityId,
    areaId,
  } = useAdvertListContext();
  const api = useApi();
  const [loadMore, { isFetching }] = api.getApiAdvertListByService().useLazyLoadMoreQuery();

  const renderLoadMoreText = useCallback((countInNextPage: number) => (
    <FormattedMessage
      defaultMessage="Load more {countInNextPage, plural, =1 {# model} other {# models}}"
      values={{ countInNextPage }}
    />
  ), []);

  const handlerLoadMore = (page: number) => {
    loadMore({
      categoryId,
      nationalityId,
      cityId,
      areaId,
      page,
      serviceId,
    });
  };

  return (
    <PaginationLoadMore
      page={pagination.page}
      pageSize={pagination.pageSize}
      totalCount={pagination.totalCount}
      isFetching={isFetching}
      loadMore={handlerLoadMore}
      loadMoreText={renderLoadMoreText}
      btnSize={ButtonSize.lg}
      btnPaddingX5
    />
  );
};

export { LoadMore };
